import firebase from 'firebase';
// Initialize Firebase
const firebaseConfig = {
  apiKey: "AIzaSyC6PsmSMSnwgljnMEpzCaVRCTR-oQgT7T4",
  authDomain: "fun-eat-produccion.firebaseapp.com",
  databaseURL: "https://fun-eat-produccion.firebaseio.com",
  //databaseURL: "http://localhost:8081",
  projectId: "fun-eat-produccion",
  storageBucket: "fun-eat-produccion.appspot.com",
  //messagingSenderId: "199593138345",
  appId: "1:199593138345:web:ceacb4a244a43512c4b1b8",
  measurementId: "G-KK3M8BGV0R"
};
let app = firebase.initializeApp(firebaseConfig);
const projectId = "fun-eat-produccion";
const db = firebase.firestore();
//db.settings({ host: "localhost:8081", ssl: false });
const functions = firebase.functions();
const storage = firebase.storage();

if (process.env.NODE_ENV === 'development') {
  functions.useEmulator('localhost', 5000)
  // db.useEmulator("localhost", 8083);
} else {

}
export { db, functions, storage, projectId };